<template>
  <div class="login-container">
    <div class="login-header">
    </div>
    <div class="login-body">
      <div class="login-context">
        <div class="login-main-right">
          <div class="header-box">
            <div class="welcome-name">欢迎登录</div>
            <div class="space-line"></div>
            <div class="system-name">{{systemName}}</div>
          </div>
          <div class="form-box">
            <el-form @submit.native.prevent :model="loginForm" :rules="rules" ref="loginForm" label-width="0" class="login-form">
              <el-form-item prop="mobilePhone" label-width="0px" class="form-input">
                <el-input v-model="loginForm.mobilePhone" autocomplete="off"
                          prefix-icon="el-icon-user"
                          clearable
                          placeholder="请输入账号"
                          @keyup.enter.native="submitForm()"
                >

                </el-input>
              </el-form-item>
              <el-form-item prop="password" label-width="0px" class="form-input">
                <el-input type="password" v-model="loginForm.password"
                          autocomplete="off"
                          prefix-icon="el-icon-lock"
                          clearable
                          placeholder="请输入密码"
                          @keyup.enter.native="submitForm()"></el-input>
              </el-form-item>
              <el-form-item label-width="0px">
                <div class="center">
                  <el-button type="primary" class="button" :loading="loading" @click="submitForm()">登录
                  </el-button>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
  const md5 = require('md5-js');

  export default {
    components: {},
    data() {
      // 密码校验
      let validateUser = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入账号'));
        } else {
          callback();
        }
      };
      // 密码校验
      let validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          callback();
        }
      };
      return {
        systemName: "XXX系统",
        loginForm: {
          loginType: "pwdLogin", // pwdLogin、smsCodeLogin
          area: '+86',
          mobilePhone: 'sunflower',
          password: 'sunflower',
          smsCodeKey: null,
          smsCode: null,
        },
        redirect: null,
        loading: false,
        rules: {
          mobilePhone: [
            {validator: validateUser, trigger: 'blur'}
          ],
          password: [
            {validator: validatePass, trigger: 'blur'}
          ],
        }
      };
    },
    watch: {
      $route: {
        handler: function (route) {
          this.redirect = route.query && route.query.redirect;
        },
        immediate: true
      }
    },
    computed: {
    },
    methods: {
      /**
       * 登录
       */
      submitForm() {
        this.$refs["loginForm"].validate(valid => {
          if (valid) {
            if (!this.loginForm.mobilePhone || !this.loginForm.password) return;
            this.loading = true;
            this.loginForm.password = md5(this.loginForm.password);
            this.$store.dispatch('doLogin', this.loginForm).then(() => {
              this.loading = false;
              window.location.href = "/"
            }).catch(() => {
              this.loading = false;
            });
          }
        });
      }
    },
  };
</script>

<style scoped lang="less">
  .login-container {
    height: 100vh;
    width: 100%;
    background: url("../../assets/img/login-bg.png") no-repeat center fixed;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;

    .login-header {
      margin: 30px 20px 60px 20px;
      padding-left: 40px;
      position: absolute;
    }

    .login-body {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      overflow: hidden;

      .login-context {
        /*width: 932px;*/
        width: 500px;
        height: 500px;
        display: flex;
        flex-direction: row;
        align-items: center;
        background: transparent;
        transform-origin: center;
        border: none;
        border-radius: 1rem;
        position: absolute;
        top: 12%;

        .login-main-left {
          position: relative;

          .login-left-bg {
            width: 428px;
            height: 500px;
          }
        }

        .login-main-right {
          flex: 1;
          height: 93%;
          display: flex;
          flex-direction: column;
          background-color: #ffffff;
          //background-color: #f2f6fccc;
          background-image: url(../../assets/img/login_form_right.png);
          background-repeat: no-repeat;
          background-position: right bottom;
          /*padding-left: 25%;*/
          /*padding-right: 5%;*/
          /*margin-left: -20%;*/
          padding-left: 5%;
          padding-right: 5%;
          border-radius: 1rem;

          .header-box {
            display: flex;
            align-items: flex-end;
            justify-content: center;
            margin-top: 82px;

            .welcome-name {
              font-weight: 700;
              font-style: normal;
              font-size: 30px;
              color: #324157;
            }

            .space-line {
              width: 2px;
              height: 1.35rem;
              background-color: #cccccc;
              margin: 0 1rem 0 2.2rem;
            }

            .system-name {
              font-weight: 400;
              font-size: 18px;
              color: #333333;
            }
          }

          .form-box {
            margin-top: 50px;

            .form-input {
              padding: 10px;
              height: 56px;
              line-height: 56px;
            }

            .center {
              text-align: center;
            }

            .button {
              width: 100%;
              height: 56px;
              /*background-color: #b80000;*/
              font-size: 16px;
              border: 0;
              border-radius: 2rem;
              color: white;
              margin-top: 52px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
</style>
